import { SAAS_FREE_EXCEL_CAPS } from "../constants/saasPlansCatalog";

/**
 * Client-side Free cap summary when entitlements API is unavailable or partial.
 * Mirrors API getFreeCapSummary shape for header meters, gates, and sidebar crowns.
 */
export function buildDefaultClientFreeCaps(usage = {}) {
  const draftsUsed = Number(usage.normalDraftsUsed || 0);
  const publishedUsed = Number(usage.publishedCampaignsUsed || 0);
  const fontUsed = Number(usage.fontUploadsUsed || 0);
  const deconstructUsed = Number(usage.deconstructUsed || 0);
  const bulkUsed = Number(usage.bulkImportsUsed || 0);
  const lmsUsed = Number(usage.lmsAuthoringUsed || 0);
  const pvUsed = Number(usage.personalizedVideoGeneratesUsed || 0);
  const renderedDraftId = usage.renderedDraftId ?? null;
  const personalizedCampaignId = usage.personalizedCampaignId ?? null;

  return {
    applies: true,
    plan: "free",
    usage: {
      normalDraftsUsed: draftsUsed,
      publishedCampaignsUsed: publishedUsed,
      fontUploadsUsed: fontUsed,
      deconstructUsed,
      bulkImportsUsed: bulkUsed,
      lmsAuthoringUsed: lmsUsed,
      personalizedVideoGeneratesUsed: pvUsed,
      renderedDraftId,
      personalizedCampaignId,
    },
    remaining: {
      normalDrafts: SAAS_FREE_EXCEL_CAPS.normalDrafts == null
        ? null
        : Math.max(0, SAAS_FREE_EXCEL_CAPS.normalDrafts - draftsUsed),
      renderedDrafts: SAAS_FREE_EXCEL_CAPS.renderedDrafts == null
        ? null
        : (renderedDraftId ? 0 : SAAS_FREE_EXCEL_CAPS.renderedDrafts),
      personalizedCampaigns: SAAS_FREE_EXCEL_CAPS.personalizedCampaigns == null
        ? null
        : (personalizedCampaignId ? 0 : SAAS_FREE_EXCEL_CAPS.personalizedCampaigns),
      publishedCampaigns: Math.max(0, SAAS_FREE_EXCEL_CAPS.publishedCampaigns - publishedUsed),
      fontUploads: Math.max(0, SAAS_FREE_EXCEL_CAPS.fontUploads - fontUsed),
      deconstruct: Math.max(0, SAAS_FREE_EXCEL_CAPS.deconstructLinks - deconstructUsed),
      bulkImports: Math.max(0, SAAS_FREE_EXCEL_CAPS.bulkImportJobs - bulkUsed),
      lmsAuthoring: Math.max(0, SAAS_FREE_EXCEL_CAPS.lmsAuthoring - lmsUsed),
      personalizedVideoGenerates: SAAS_FREE_EXCEL_CAPS.personalizedVideoGenerates == null
        ? null
        : Math.max(0, SAAS_FREE_EXCEL_CAPS.personalizedVideoGenerates - pvUsed),
      maxVideoSec: SAAS_FREE_EXCEL_CAPS.personalizedVideoSec,
      maxPersonalizedAudioSec: SAAS_FREE_EXCEL_CAPS.personalizedAudioSec,
      maxAttemptsPerClip: SAAS_FREE_EXCEL_CAPS.retriesPerCampaign,
      maxRetriesPerCampaign: SAAS_FREE_EXCEL_CAPS.retriesPerCampaign,
      personalizedVideoMaxElements: SAAS_FREE_EXCEL_CAPS.personalizedVideoMaxElements,
      productVideoMaxPersonalizedAudio: SAAS_FREE_EXCEL_CAPS.productVideoMaxPersonalizedAudio,
      imagesMaxPersonalizedAudio: SAAS_FREE_EXCEL_CAPS.imagesMaxPersonalizedAudio,
      pipMaxPersonalizedAudio: SAAS_FREE_EXCEL_CAPS.pipMaxPersonalizedAudio,
      framesMaxPersonalizedAudio: SAAS_FREE_EXCEL_CAPS.framesMaxPersonalizedAudio,
      bgMusicMaxPersonalizedAudio: SAAS_FREE_EXCEL_CAPS.bgMusicMaxPersonalizedAudio,
    },
  };
}
